import {Component, Input, OnInit} from '@angular/core';
import {CustomFormControl} from '../CustomFormControl';

@Component({
  selector: 'app-button-reset-fields',
  templateUrl: './button-reset-fields.component.html',
  styleUrls: ['./button-reset-fields.component.scss']
})
export class ButtonResetFieldsComponent implements OnInit {

  @Input() control!: CustomFormControl;
  @Input() controlCache!: Map<string, CustomFormControl>;

  constructor() { }

  ngOnInit(): void {
  }

  handleResetClicked(): void {
    this.resetFields();
    this.enableFields();
  }

  resetFields(): void {
    if (!this.control.element.resetFields) {
      console.error('No reset fields defined');
      return;
    }

    this.control.element.resetFields.forEach((field) => {
      const targetControl = this.controlCache.get(field);
      if (!targetControl) {
        return;
      }

      targetControl.reset();
      // targetControl.markAsDirty();
    });
  }

  enableFields(): void {
    if (!this.control.element.enableFields) {
      console.error('No enable fields defined');
      return;
    }

    this.control.element.resetFields.forEach((field) => {
      const targetControl = this.controlCache.get(field);
      if (!targetControl) {
        return;
      }

      targetControl.element.readOnly = false;
    });
  }
}
